import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Nav,
} from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useDispatch, useSelector } from "react-redux";
import ReactExport from "react-export-excel";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";
import {
  deleteGeneralInfo,
  editGeneralInfo,
  getGeneralInfo,
  getGeneralInfoById,
  saveGeneralInfo,
  editGeneralInfoById,
} from "../../../redux/descriptorsProfiles/GeneralInfo/actions";
import { Link } from "react-router-dom";
import {
  getPurpose,
  savePurpose,
} from "../../../redux/descriptorsProfiles/Purpose/actions";
import { getMeasurementUnit } from "../../../redux/descriptorsProfiles/MeasurementUnit/actions";
import {
  getJobFunction,
  saveJobFunction,
  editJobFunction,
  editFundamentalsJobFunction,
  deleteJobFunction,
} from "../../../redux/descriptorsProfiles/JobFunction/actions";

const JobDescription = (props) => {
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const filters = [
    { id: "nombre_posicion", desc: "Descriptor" },
    { id: "descripcion", desc: "Descripción" },
    { id: "posicion_id", desc: "Función" },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showModalFunction, setShowModalFunction] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [validatedFunction, setValidatedFunction] = useState(false);
  const [validatedPurpose, setValidatedPurpose] = useState(false);
  const [isSelect, setIsSelect] = useState(false);
  const [show, setShow] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre_posicion",
    desc: "Descriptor",
  });
  const [purposeSelected, setPurposeSelected] = useState([]);
  const [unitSelected, setUnitSelected] = useState([]);

  const dispatch = useDispatch();
  const userRoles = useSelector((store) => store.auth.userRoles);

  const schema = Yup.object().shape({
    descripcion: Yup.string().required("**Campo requerido"),
    proposito: Yup.string().required("**Campo requerido"),
  });

  const schemaPurpose = Yup.object().shape({
    nombre: Yup.string().required("**Campo requerido"),
    // .matches(
    //   /^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$/,
    //   "**Solo admite letras,numeros y los siguientes caracteres @$¿?!¡/-_%#."
    // )
    descripcion: Yup.string().required("**Campo requerido"),
    // .matches(
    //   /^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$/,
    //   "**Solo admite letras,numeros y los siguientes caracteres @$¿?!¡/-_%#."
    // )
  });

  const schemaFunction = Yup.object().shape({
    descripcion: Yup.string().required("**Campo requerido"),
    // .matches(
    //   /^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$/,
    //   "**Solo admite letras,numeros y los siguientes caracteres @$¿?!¡/-_%#."
    // )
    perioricidad: Yup.number()
      .integer("El número no debe tener decimales")
      .required("**Campo requerido")
      .typeError("Debe especificar un numero"),
    concecuencias_error: Yup.number()
      .integer("El número no debe tener decimales")
      .required("**Campo requerido")
      .typeError("Debe especificar un numero"),
    complejidad: Yup.number()
      .integer("El número no debe tener decimales")
      .required("**Campo requerido")
      .typeError("Debe especificar un numero"),
    // unidad_medida: Yup.string().required("**Campo requerido"),
    // meta: Yup.number()
    //   .required("**Campo requerido")
    //   .typeError("Debe especificar un numero"),
  });

  const { jobFunctionsLength, jobFunctions, jobFunctionError } = useSelector(
    (store) => store.jobFunction
  );
  const jobLoading = useSelector((store) => store.jobFunction.loading);
  const jobSaveLoading = useSelector((store) => store.jobFunction.saveLoading);
  const jobFormError = useSelector((store) => store.jobFunction.formError);
  const pages = Math.ceil(jobFunctionsLength / limit);

  const {
    generalInfo,
    loadingById,
    generalInfoError,
    saveLoading,
    formError,
    saveLoadingById,
  } = useSelector((store) => store.generalInfo);

  const { purposesLength, purposes, purposesError } = useSelector(
    (store) => store.purpose
  );
  const purposeSaveLoading = useSelector((store) => store.purpose.saveLoading);

  const { measurementUnitsLength, measurementUnits, measurementUnitError } =
    useSelector((store) => store.measurementUnit);

  let purposeOptions = [];
  purposes &&
    purposes.map((task) => {
      purposeOptions = [
        ...purposeOptions,
        {
          id: task.id,
          label: task.nombre,
        },
      ];
    });

  let measurementUnitOptions = [];
  measurementUnits &&
    measurementUnits.map((unit) => {
      measurementUnitOptions = [
        ...measurementUnitOptions,
        {
          id: unit.id,
          label: unit.descripcion,
        },
      ];
    });

  const columns = [
    {
      Header: "Función del puesto",
      accessor: "descripcion",
    },
    {
      Header: "P",
      Filter: "",
      Cell: (value) => <div>{value.row.original.perioricidad}</div>,
    },
    {
      Header: "C",
      Filter: "",
      Cell: (value) => <div>{value.row.original.complejidad}</div>,
    },
    {
      Header: "CE",
      Filter: "",
      Cell: (value) => <div>{value.row.original.concecuencias_error}</div>,
    },
    {
      Header: "Total",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.perioricidad +
            value.row.original.complejidad *
              value.row.original.concecuencias_error}
        </div>
      ),
    },
    // {
    //   Header: "Meta",
    //   Filter: "",
    //   Cell: (value) => <div>{value.row.original.meta}</div>,
    // },
    {
      id: "customCheckbox",
      // Header: "Fundamentales",
      Filter: "",
      Cell: (value) =>
      props.match.params.miDescriptor ? null : (
          <div className="btn-group" role="group">
            <Form.Check
              inline
              value={JSON.stringify({
                value: value.row.original,
                indexT: value.row.index,
              })}
              // disabled={}
              onChange={handleCheckbox}
              defaultChecked={value.row.original.fundamental}
            />
          </div>
        ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) =>
      props.match.params.miDescriptor ? null : (
          <div className="btn-group" role="group">
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </div>
        ),
    },
  ];

  // Métodos
  const _getJobFunction = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getJobFunction({
        offset: offs,
        limit: lim,
        tipo_busqueda: "descriptor",
        filter: parseInt(props.match.params.id),
      })
    );

  useEffect(() => {
    _getJobFunction();
    dispatch(getPurpose({}));
    dispatch(getGeneralInfoById(parseInt(props.match.params.id)));
    setPurposeSelected([]);
    dispatch(getMeasurementUnit({}));
    setValidated(false);
  }, [props.match.params.id]);

  useEffect(() => {
    if (generalInfo && generalInfo.list_proposito_general) {
      setPurposeSelected([
        {
          id: generalInfo.list_proposito_general[0].id,
          label: generalInfo.list_proposito_general[0].nombre,
        },
      ]);
    } else {
      setPurposeSelected([]);
      setIsSelect(false);
    }
  }, [generalInfo]);

  useEffect(() => {
    if (isSelect) {
      let cnt = purposes.length - 1;
      setPurposeSelected([
        {
          id: purposes[cnt].id,
          label: purposes[cnt].nombre,
        },
      ]);
      setIsSelect(false);
    }
  }, [isSelect]);

  const onAdd = () => {
    setShowModal(true);
    // setEdit(false);
    setValidatedPurpose(false);
  };

  const onAddFunction = () => {
    setUnitSelected([]);
    setShowModalFunction(true);
    setEdit(false);
    setValidatedFunction(false);
  };

  const onEdit = (item, index) => {
    if (item.list_unidad_medida) {
      setUnitSelected([
        {
          id: item.list_unidad_medida[0].id,
          label: item.list_unidad_medida[0].descripcion,
        },
      ]);
    }
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModalFunction(true);
    setValidatedFunction(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getJobFunction(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    const _req = {
      descripcion_larga: req.descripcion,
      proposito_general: req.proposito,
      nombre_posicion: generalInfo.nombre_posicion,
    };
    dispatch(
      editGeneralInfoById(_req, parseInt(props.match.params.id), setValidated)
    );
  };

  const onSubmitPurpose = async (req) => {
    const _req = {
      nombre: req.nombre,
      descripcion: req.descripcion,
      fecha_creacion: moment(new Date()).format("YYYY-MM-DD"),
    };

    // if (!edit) {
    dispatch(savePurpose(_req, setShowModal, true, setIsSelect));
    // } else {
    //   dispatch(editPurpose(_req, editItem.id, index, setShowModal));
    // }
    // setIsSelect(true);
  };

  const onSubmitFunction = async (req) => {
    const _req = {
      descripcion: req.descripcion,
      perioricidad: parseInt(req.perioricidad),
      complejidad: parseInt(req.complejidad),
      concecuencias_error: parseInt(req.concecuencias_error),
      // unidad_medida: parseInt(req.unidad_medida),
      // meta: parseFloat(req.meta),
      descriptor: parseInt(props.match.params.id),
      fundamental: false,
    };

    if (!edit) {
      dispatch(saveJobFunction(_req, setShowModalFunction));
    } else {
      dispatch(editJobFunction(_req, editItem.id, index, setShowModalFunction));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getJobFunction(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteJobFunction(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const handleCheckbox = ({ target: { checked, value: checkValue } }) => {
    let { value, indexT } = JSON.parse(checkValue);
    if (checked) {
      // const value = JSON.parse(checkValue);
      const _req1 = {
        descripcion: value.descripcion,
        perioricidad: parseInt(value.perioricidad),
        complejidad: parseInt(value.complejidad),
        concecuencias_error: parseInt(value.concecuencias_error),
        unidad_medida: parseInt(value.unidad_medida),
        meta: parseFloat(value.meta),
        descriptor: parseInt(props.match.params.id),
        fundamental: true,
      };
      dispatch(editFundamentalsJobFunction(_req1, parseInt(value.id), indexT));
    } else {
      const _req2 = {
        descripcion: value.descripcion,
        perioricidad: parseInt(value.perioricidad),
        complejidad: parseInt(value.complejidad),
        concecuencias_error: parseInt(value.concecuencias_error),
        unidad_medida: parseInt(value.unidad_medida),
        meta: parseFloat(value.meta),
        descriptor: parseInt(props.match.params.id),
        fundamental: false,
      };
      dispatch(editFundamentalsJobFunction(_req2, parseInt(value.id), indexT));
    }
  };

  return (
    <>
      {loadingById ? (
        <div className="d-flex justify-content-center">
          <Spinner
            animation="border"
            role="status"
            className="d-flex justify-content-center"
          />
        </div>
      ) : (
        <Container fluid>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              descripcion:
                generalInfo && generalInfo ? generalInfo.descripcion_larga : "",
              proposito:
                generalInfo && generalInfo
                  ? generalInfo.proposito_general
                    ? generalInfo.proposito_general
                    : ""
                  : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              setFieldValue,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Col className="my-4">
                  <Col className="mx-3 d-flex flex-wrap justify-content-between align-items-center">
                    <Row className="pl-md-4 pr-md-3 pl-2 pr-1 justify-content-end align-items-center flex-nowrap">
                      <h6 className="font-weight-bold text-uppercase">
                        Descriptor del puesto
                      </h6>
                      <Col xs="auto">
                        {props.match.params.miDescriptor ? null : (
                          <Button
                            className="rounded-pill"
                            variant="primary"
                            disabled={saveLoadingById}
                            type="submit"
                          >
                            {saveLoadingById && (
                              <Spinner
                                className="mr-2"
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            )}
                            Guardar <i className="material-icons">save</i>
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <hr />
                  </Col>
                </Col>
                <Col>
                  {!!formError && (
                    <Alert variant="danger" className="mt-4 mb-1 mx-3">
                      {formError}
                    </Alert>
                  )}
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12">
                      Proposito general del puesto
                    </Form.Label>
                    <Row>
                      <Col
                       
                        md={11}
                      >
                        <Typeahead
                          id="proposito"
                          name="proposito"
                          isInvalid={touched.proposito && errors.proposito}
                          isValid={touched.proposito && !errors.proposito}
                          onBlur={handleBlur("proposito")}
                          placeholder="Proposito general"
                          options={purposeOptions}
                          onChange={(selected) => {
                            setFieldValue(
                              "proposito",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setPurposeSelected(selected);
                          }}
                          selected={purposeSelected}
                          disabled={ props.match.params.miDescriptor
                          }
                        ></Typeahead>
                      </Col>
                      { props.match.params.miDescriptor ? null : (
                        <Col sm="2" md="1">
                          <Button
                            variant="light"
                            size="sm"
                            className="rounded-circle"
                            onClick={() => onAdd()}
                          >
                            <i className="material-icons">add</i>
                          </Button>
                        </Col>
                      )}
                    </Row>
                    {touched.proposito && errors.proposito && (
                      <div>
                        <small className="text-danger">
                          {errors.proposito}
                        </small>
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Descripción larga
                    </Form.Label>
                    {/* <Col sm="12" md="8"> */}
                    <Form.Control
                      id="descripcion"
                      name="descripcion"
                      isInvalid={touched.descripcion && errors.descripcion}
                      isValid={touched.descripcion && !errors.descripcion}
                      onBlur={handleBlur("descripcion")}
                      onChange={handleChange}
                      value={values.descripcion}
                      className="rounded"
                      as="textarea"
                      placeholder="Descripción"
                      disabled={
                        props.match.params.miDescriptor
                      }
                    ></Form.Control>
                    {touched.descripcion && errors.descripcion && (
                      <div>
                        <small className="text-danger">
                          {errors.descripcion}
                        </small>
                      </div>
                    )}
                    {/* </Col> */}
                  </Form.Group>
                </Col>
              </Form>
            )}
          </Formik>
          <Col className="mt-4">
            <Col className="mx-3 d-flex flex-wrap justify-content-between align-items-center">
              <Row className="pl-md-4 pr-md-3 pl-2 pr-1 justify-content-end align-items-center flex-nowrap">
                <h6 className="font-weight-bold text-uppercase">
                  Funciones del puesto
                </h6>
                { props.match.params.miDescriptor ? null : (
                  <>
                    <Col xs="auto">
                      <Button
                        variant="primary"
                        size="sm"
                        className="rounded-pill"
                        onClick={() => onAddFunction()}
                      >
                        Crear nuevo <i className="material-icons">add</i>
                      </Button>
                    </Col>
                    <p>
                      <i className="material-icons text-info">info</i>{" "}
                      Seleccione al menos 5 funciones
                    </p>
                  </>
                )}
              </Row>
            </Col>
          </Col>
          <Col>
            <Col className="px-2">
              {jobLoading ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : (
                jobFunctionsLength > 0 && (
                  <>
                    <Card className="border-0">
                      <Card.Body className="px-1 px-sm-2">
                        <div className="mx-1 border-left border-warning">
                          <Alert variant="light">
                            <p>
                              Las primeras 3 funciones se tomarán en cuenta para
                              la evaluación del desempeño por factores.
                            </p>
                          </Alert>
                        </div>
                        <CustomTable columns={columns} data={jobFunctions} />
                      </Card.Body>
                    </Card>
                    <CustomPagint
                      limit={limit}
                      setLimit={setLimit}
                      offset={offset}
                      setOffset={setOffset}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      dataLenght={jobFunctionsLength}
                      pages={pages}
                      pagFunc={_getJobFunction}
                    />
                  </>
                )
              )}
              {!jobLoading &&
                jobFunctionsLength === 0 &&
                jobFunctionError === "" && (
                  <Alert variant="info" className="my-4">
                    Aún no hay registros, comience agregando algunos
                  </Alert>
                )}
              {!!jobFunctionError && (
                <Alert variant="danger" className="mt-4 mb-1">
                  {jobFunctionError}
                </Alert>
              )}
            </Col>
          </Col>
        </Container>
      )}
      {/* </div> */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schemaPurpose}
          onSubmit={onSubmitPurpose}
          initialValues={{
            nombre: "",
            descripcion: "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form
              onSubmit={handleSubmit}
              noValidate
              validated={validatedPurpose}
            >
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar propósito" : "Crear propósito"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!purposesError && (
                  <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                    {purposesError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Nombre
                  </Form.Label>
                  <Form.Control
                    id="nombre"
                    name="nombre"
                    isInvalid={touched.nombre && errors.nombre}
                    isValid={touched.nombre && !errors.nombre}
                    onBlur={handleBlur("nombre")}
                    onChange={handleChange}
                    value={values.nombre}
                    className="rounded-pill mb-4"
                    type="text"
                    placeholder="Nombre del Propósito"
                  ></Form.Control>
                  <Form.Label column sm="12" md="12">
                    Descripción:
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    id="descripcion"
                    name="descripcion"
                    aria-label=""
                    isInvalid={touched.descripcion && errors.descripcion}
                    isValid={touched.descripcion && !errors.descripcion}
                    onBlur={handleBlur("descripcion")}
                    onChange={handleChange}
                    value={values.descripcion}
                    placeholder="Descripción del propósito"
                  ></Form.Control>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={purposeSaveLoading}
                  type="submit"
                >
                  {purposeSaveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal
        show={showModalFunction}
        onHide={() => setShowModalFunction(false)}
      >
        <Formik
          validationSchema={schemaFunction}
          onSubmit={onSubmitFunction}
          initialValues={{
            descripcion: edit ? editItem.descripcion : "",
            perioricidad: edit ? editItem.perioricidad : null,
            complejidad: edit ? editItem.complejidad : null,
            concecuencias_error: edit ? editItem.concecuencias_error : null,
            // unidad_medida: edit ? editItem.unidad_medida : "",
            // meta: edit ? editItem.meta : null,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form
              onSubmit={handleSubmit}
              noValidate
              validated={validatedFunction}
            >
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar Función" : "Crear Función"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!jobFormError && (
                  <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                    {jobFormError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Descripción de la función
                  </Form.Label>
                  <Form.Control
                    id="descripcion"
                    name="descripcion"
                    isInvalid={
                      touched.descripcion && errors.descripcion
                      // ||
                      // touched.descripcion
                      // &&
                      // formErrorJson &&
                      // typeof formErrorJson === "object" &&
                      // formErrorJson.descripcion
                    }
                    isValid={touched.descripcion && !errors.descripcion}
                    onBlur={handleBlur("descripcion")}
                    onChange={handleChange}
                    value={values.descripcion}
                    as="textarea"
                  ></Form.Control>
                  {touched.descripcion && errors.descripcion && (
                    <Col>
                      <small className="text-danger">
                        {errors.descripcion}
                      </small>
                    </Col>
                  )}
                  {/* {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.descripcion ? (
                    <Col>
                      {formErrorJson.descripcion.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null} */}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Periodicidad
                  </Form.Label>
                  <Form.Control
                    id="perioricidad"
                    name="perioricidad"
                    isInvalid={
                      touched.perioricidad && errors.perioricidad
                      // ||
                      // touched.perioricidad
                      // &&
                      // formErrorJson &&
                      // typeof formErrorJson === "object" &&
                      // formErrorJson.archivo
                    }
                    isValid={touched.perioricidad && !errors.perioricidad}
                    onBlur={handleBlur("perioricidad")}
                    onChange={handleChange}
                    value={values.perioricidad}
                    className="rounded-pill"
                    type="number"
                    placeholder="0"
                  ></Form.Control>
                  {touched.perioricidad && errors.perioricidad && (
                    <Col>
                      <small className="text-danger">
                        {errors.perioricidad}
                      </small>
                    </Col>
                  )}
                  {/* {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.archivo ? (
                    <Col>
                      {formErrorJson.archivo.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null} */}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Consecuencias del error
                  </Form.Label>
                  <Form.Control
                    id="concecuencias_error"
                    name="concecuencias_error"
                    isInvalid={
                      touched.concecuencias_error && errors.concecuencias_error
                      //   ||
                      // touched.concecuencias_error
                      // &&
                      // formErrorJson &&
                      // typeof formErrorJson === "object" &&
                      // formErrorJson.archivo
                    }
                    isValid={
                      touched.concecuencias_error && !errors.concecuencias_error
                    }
                    onBlur={handleBlur("concecuencias_error")}
                    onChange={handleChange}
                    value={values.concecuencias_error}
                    className="rounded-pill"
                    type="number"
                    placeholder="0"
                  ></Form.Control>
                  {touched.concecuencias_error &&
                    errors.concecuencias_error && (
                      <Col>
                        <small className="text-danger">
                          {errors.concecuencias_error}
                        </small>
                      </Col>
                    )}
                  {/* {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.archivo ? (
                    <Col>
                      {formErrorJson.archivo.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null} */}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Complejidad
                  </Form.Label>
                  <Form.Control
                    id="complejidad"
                    name="complejidad"
                    isInvalid={
                      touched.complejidad && errors.complejidad
                      // ||
                      // touched.complejidad
                      // &&
                      // formErrorJson &&
                      // typeof formErrorJson === "object" &&
                      // formErrorJson.archivo
                    }
                    isValid={touched.complejidad && !errors.complejidad}
                    onBlur={handleBlur("complejidad")}
                    onChange={handleChange}
                    value={values.complejidad}
                    className="rounded-pill"
                    type="number"
                    placeholder="0"
                  ></Form.Control>
                  {touched.complejidad && errors.complejidad && (
                    <Col>
                      <small className="text-danger">
                        {errors.complejidad}
                      </small>
                    </Col>
                  )}
                  {/* {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.archivo ? (
                    <Col>
                      {formErrorJson.archivo.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null} */}
                </Form.Group>
                {/* <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Unidad de medida
                  </Form.Label>
                  <Typeahead
                    id="unidad_medida"
                    name="unidad_medida"
                    isInvalid={touched.unidad_medida && errors.unidad_medida}
                    isValid={touched.unidad_medida && !errors.unidad_medida}
                    onBlur={handleBlur("unidad_medida")}
                    placeholder="Unidad de medida"
                    options={measurementUnitOptions}
                    onChange={(selected) => {
                      setFieldValue(
                        "unidad_medida",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setUnitSelected(selected);
                    }}
                    selected={unitSelected}
                    disabled={measurementUnitsLength === 0}
                  ></Typeahead>
                  {touched.unidad_medida && errors.unidad_medida && (
                    <div>
                      <small className="text-danger">
                        {errors.unidad_medida}
                      </small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Meta
                  </Form.Label>
                  <Form.Control
                    id="meta"
                    name="meta"
                    isInvalid={
                      touched.meta && errors.meta
                      || touched.meta
                      &&
                      formErrorJson &&
                      typeof formErrorJson === "object" &&
                      formErrorJson.archivo
                    }
                    isValid={touched.meta && !errors.meta}
                    onBlur={handleBlur("meta")}
                    onChange={handleChange}
                    value={values.meta}
                    className="rounded-pill"
                    type="number"
                    placeholder="0.00"
                  ></Form.Control>
                  {touched.meta && errors.meta && (
                    <Col>
                      <small className="text-danger">{errors.meta}</small>
                    </Col>
                  )}
                  {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.archivo ? (
                    <Col>
                      {formErrorJson.archivo.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null}
                </Form.Group> */}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModalFunction(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={jobSaveLoading}
                  type="submit"
                >
                  {jobSaveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default JobDescription;
